import PieChartIcon from '@mui/icons-material/PieChart';
import React, { memo } from 'react';
import TableChartIcon from '@mui/icons-material/TableChart';
import {
  Box, Paper, Stack, Typography,
} from '@mui/material';
import { Handle, Position } from 'reactflow';
import { styled } from '@mui/material/styles';


// Styled component for the node box
const StyledBox = styled(Box)(({ theme, isChildNode }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '4px',
  position: 'relative', // Ensure ::before works correctly
  '&::before': {
    boxSizing: 'border-box',
    content: '""',
    width: '12px',
    backgroundColor: isChildNode ? theme.palette.info.main : theme.palette.primary.main,
    position: 'absolute',
    left: 0,
    top: 0,
    bottom: 0,
    borderTopLeftRadius: '4px',
    borderBottomLeftRadius: '4px',
  },
}));

// Helper function to render the appropriate icon
const getNodeIcon = (isChildNode) => (
  isChildNode ? <PieChartIcon color='secondary' /> : <TableChartIcon color='secondary' />
);

// Reusable Handle component
const NodeHandle = ({
  type, position, id, isConnectable,
}) => (
  <Handle type={type} position={position} id={id} isConnectable={isConnectable} />
);

const AssetNode = memo(({ data, isConnectable }) => (
  <>
    {data.isChildNode && (
      <NodeHandle type='target' position={Position.Left} id='b' isConnectable={isConnectable} />
    )}
    <Paper elevation={3}>
      <StyledBox gap={1} p={2} isChildNode={data.isChildNode}>
        {getNodeIcon(data.isChildNode)}
        <Stack>
          <Typography variant='subtitle1' color='secondary' aria-label='Node Name'>
            {data.name}
          </Typography>
          {data.assetType && (
            <Typography variant='body2' color='secondary' aria-label='Asset Type'>
              {data.assetType}
            </Typography>
          )}
        </Stack>
      </StyledBox>
    </Paper>
    <NodeHandle type='source' position={Position.Right} id='a' isConnectable={isConnectable} />
  </>
));

AssetNode.displayName = 'AssetNode';

export default AssetNode;
